export const animatedCircle = {
  animate: function () {
    const sizes = animatedCircle.setSizes();

    $(".animatedCircle").each(function(){
      if (document.readyState === 'complete' && $(this).attr("data-animated") === "false" && animatedCircle.isInViewPort($(this))) {
        $(this).attr("data-animated", "true");
        const colour = $(this).attr("data-colour");
        const percentage = $(this).attr("data-percentage")/100;
        const countTo = $(this).attr("data-percentage");

        const outer = $(this).find('.animated-circle__outer');
        const inner = $(this).find('.animated-circle__inner');

        animatedCircle.drawCircle(outer, sizes.outer, sizes.thickness, colour, percentage, 0.05, 0.1);
        animatedCircle.drawCircle(inner, sizes.inner, sizes.thickness, colour, percentage, 0.15, 0.2);

        animatedCircle.countTo($(this).find('.circleCounter'), countTo);
      }
    })
  },

  setSizes : function () {
    const sizes = {};
    sizes.inner = 140;
    sizes.outer = 180;
    sizes.thickness = 20;

    if(window.innerWidth >= 768) {
      sizes.inner = 150;
      sizes.outer = 200;
      sizes.thickness = 25;
    }

    if(window.innerWidth >= 1200) {
      sizes.inner = 190;
      sizes.outer = 250;
      sizes.thickness = 30;
    }
    return sizes;
  },

  drawCircle: function (element, size, thickness, colour, percentage, opacityEmpty, opacityFilled) {
    element.circleProgress({
      value: percentage,
      size: size,
      fill: {
        color: hexToRGB(colour, opacityFilled)
      },
      emptyFill: hexToRGB(colour, opacityEmpty),
      thickness: thickness,
      startAngle: -Math.PI/2,
      animation: { duration: 2000, easing: "circleProgressEasing" }
    });
  },

  countTo: function(element, countTo) {
    let percent = '' + countTo;
    percent = percent.replace('.', ',');
    element.prop('integerNum', 0).animate({
        integerNum: Math.floor(countTo),
        countNum: percent
      },
      {
        queue: false,
        duration: 2000,
        easing:'linear',
        progress: function() {
          $(this).text(Math.round(this.integerNum));
        },
        done: function() {
          $(this).text(percent);
        }
    });
  },

  isInViewPort: function(element) {
    let topOfElement = element.offset().top;
    let bottomOfElement = element.offset().top + element.outerHeight();
    let bottomOfScreen = $(window).scrollTop() + window.innerHeight;
    let topOfScreen = $(window).scrollTop();

    if((bottomOfScreen > topOfElement) && (topOfScreen < bottomOfElement)) return true;

    return false;
  },

  resetCirclesAnimation: function() {
    $(".animatedCircle").each(function() {
      $(this).attr("data-animated", false);
    });
  }
}
